module.exports = __webpack_public_path__ + "assets/Excessive Overjet.5e9168118ab7163bb53ebb5446c608b1.svg";